const BASE = "/suppliers";

export const SUPPLIERS_ENDPOINTS = {
  GET_SUPPLIERS: BASE,
  GET_SUPPLIER: (id: string) => `${BASE}/${id}`,
  CREATE_SUPPLIER: BASE,
  UPDATE_SUPPLIER: (id: string) => `${BASE}/${id}`,
  DELETE_SUPPLIER: (id: string) => `${BASE}/${id}`,
  DELETE_SUPPLIERS: `${BASE}/destroy_in_batch`,
} as const;
